(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const faqElement = document.querySelectorAll('.faq-q');
	faqElement.forEach(faqElement => {
      faqElement.addEventListener('click', function(){
        this.classList.toggle("faq-q-open");
        let faqPanel = this.nextElementSibling.querySelector('.faq-a');
        if (faqPanel.style.display === "block") {
          faqPanel.style.display = "none";
        } else {
          faqPanel.style.display = "block";
        }
      });
    });
});

  } catch(e) { console.error(e); }
})();
})();
